module.exports = __webpack_public_path__ + "media/images/administrator_profile-8d5a7e2b676a3d44863b2a17f24d1d4a.png";